"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var changeLanguage_1 = require("./changeLanguage");
function i18nTestProvider(i18nextInstance) {
    return {
        initialize: function (_a) {
            var englishStrings = _a.englishStrings, frenchStrings = _a.frenchStrings;
            i18nextInstance.init({
                lng: 'cimode',
                debug: false,
            });
        },
        addLanguages: function (languages, resources) {
            // noop
        },
        changeLanguage: function (lang) {
            return changeLanguage_1.default(i18nextInstance, lang).then(function () {
                window.location.reload();
            });
        },
        getCurrentLanguage: function () {
            return 'cimode';
        },
        translate: function (key, options) {
            return i18nextInstance.t(key, options);
        },
    };
}
exports.default = i18nTestProvider;
